import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { generalClient } from '../../../../../utils/apollo/api'

const MUTATION = gql`
  mutation RemoveLinkTrees($ids: [Int]) {
    removeLinkTrees(ids: $ids)
  }
`

export const useRemoveLinkTree = () => {
  const modal = useAlert()
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['LinkTrees', 'LinkTreeCount'],
    client: generalClient
  })
  const { t } = useTranslation('common')
  const notify = useNotification()

  const handleRequest = ids => {
    if (!modal.confirm({ title: t('confirmRemove') })) return false
    if (!ids) return
    return request({ variables: { ids } }).then(resp => {
      if (resp.errors) notify.error({ title: t('errorDelete') })
    })
  }

  return [handleRequest, state]
}
